import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  companiesList : [
    {
      label: "",
      id: 0,
    },
  ],
  discountedRate: [],
  addOnList: [],
  searchTaxResult: [],
  taxRateData : 0,
  taxRateFlatData : 0
};


const editReservationSlice = createSlice({
  name: "editReservation",
  initialState: initialState,
  reducers: {
    companiesListSuccess: (state, action) => {
      state.companiesList = action.payload;
    },
    companiesListFailed: () => {
      state.companiesList = [];
    },
    discountedRateSuccess: (state, action) => {
      state.discountedRate = action.payload;
    },
    discountedRateFailed: () => {
      state.discountedRate = [];
    },
    addOnListSuccess: (state, action) => {
      state.addOnList = action.payload;
    },
    addOnListFailed: () => {
      state.addOnList = [];
    },
    searchTaxResultSuccess: (state, action) => {
      state.searchTaxResult = action.payload;
      state.taxRateData = action.payload?.filter((item) => +item?.tax_type === 1)?.reduce((n, { tax_rate }) => n + +tax_rate, 0);
      state.taxRateFlatData = action.payload?.filter((item) => +item?.tax_type === 2)?.reduce((n, { tax_rate }) => n + +tax_rate, 0);
    },
    searchTaxResultFailed: () => {
      state.searchTaxResult = [];
      state.taxRateData = 0;
      state.taxRateFlatData = 0;
    },
  },
});


export const {
  companiesListSuccess,
  companiesListFailed,
  discountedRateSuccess,
  discountedRateFailed,
  addOnListSuccess,
  addOnListFailed,
  searchTaxResultSuccess,
  searchTaxResultFailed
} = editReservationSlice.actions;
export default editReservationSlice.reducer;
